module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "mapheader"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 17
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.infoContent) + "\n\t\t\t\t  ")]), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "clickable": true,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          _vm.toggleInfoWindow(m, i)
        },
        "update:icon": function($event) {
          m.icon = $event
        }
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mapcontent"
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "avatar": "",
        "to": item.link
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })], 1)], 1)
  }))], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56381390","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Historicsites.vue
// module id = 308
// module chunks = 1